export enum InvoicingCutoffClassEnum {
  expiredInvoice = 1,
  advanceInvoice = 2,
}